import React from 'react';

export function CookiePolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Cookie Policy</h1>
        <div className="prose prose-sm max-w-none">
          <p className="text-gray-600">Last updated: November 06, 2024</p>
          
          <div className="mt-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">What are cookies?</h2>
            <p className="text-gray-600 mb-4">
              Cookies are small data files that are placed on your computer or mobile device when you visit a website. 
              Cookies are widely used by website owners in order to make their websites work, or to work more efficiently, 
              as well as to provide reporting information.
            </p>
          </div>

          <div className="mt-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">How do we use cookies?</h2>
            <p className="text-gray-600 mb-4">
              We use first- and third-party cookies for several reasons. Some cookies are required for technical reasons 
              in order for our Website to operate, and we refer to these as "essential" or "strictly necessary" cookies. 
              Other cookies enable us to track and target the interests of our users to enhance the experience on our Website.
            </p>
          </div>

          <div className="mt-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Types of cookies we use</h2>
            <ul className="list-disc pl-6 space-y-4 text-gray-600">
              <li>
                <strong>Essential cookies:</strong> These cookies are strictly necessary to provide you with services 
                available through our Website and to use some of its features.
              </li>
              <li>
                <strong>Analytics cookies:</strong> These cookies help us understand how visitors interact with our 
                Website, helping us improve our services and user experience.
              </li>
              <li>
                <strong>Marketing cookies:</strong> These cookies are used to track visitors across websites to allow 
                publishers to display relevant and engaging advertisements.
              </li>
            </ul>
          </div>

          <div className="mt-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Contact Us</h2>
            <p className="text-gray-600">
              If you have questions about this Cookie Policy, please contact us at:
            </p>
            <div className="mt-2 text-gray-600">
              <p>The Art of Online Marketing</p>
              <p>17772 Irvine Blvd unit 102A</p>
              <p>Tustin, CA 92780</p>
              <p>United States</p>
              <p>Email: info@artofonline.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}